import React from "react";
import { Box, keyframes } from "@chakra-ui/react";
import { ReactComponent as Charging } from "./icons/batterycharging.svg";
import { ReactComponent as ChargingLight } from "./icons/batterycharging-light.svg";

const fade = keyframes`
  0% {
    opacity: 1;
  }
  14% {
    opacity: 0;
  }
  28% {
    opacity: 0;
  }
  42% {
    opacity: 1;
  }
`;

export default class BatteryIcon extends React.PureComponent {
  render() {
    let { state, level, isDarkMode, ...rest } = this.props;
    const charging = state === "CHARGING";
    if (charging) {
      return isDarkMode ? <ChargingLight {...rest} /> : <Charging {...rest} />;
    }

    let rectFill = isDarkMode ? "white" : "rgba(0,0,0,0.54)";
    let rectWidth = (13 * level) / 100;

    const isUnderThreshold = level < 20;
    if (isUnderThreshold) {
      rectFill = "red";
      rectWidth = (13 * 20) / 100;
    }

    return (
      <Box
        animation={`${fade} 2200ms infinite`}
        sx={{
          animationPlayState: isUnderThreshold ? "running" : "paused"
        }}
        {...rest}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
        >
          <g fill="#000" fillRule="nonzero">
            <rect
              fill={rectFill}
              width={rectWidth}
              height="8"
              x="2"
              y="5"
              rx="1"
            />
            <path
              fill={isDarkMode ? "white" : "black"}
              d="M17 8a1 1 0 0 1 0 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v3zM2 4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H2z"
            />
          </g>
        </svg>
      </Box>
    );
  }
}
